<div class="container">
  <div class="text">
    <span class="noselect intro">L - {{ positionFromLeftLimit }} mm</span>
    <span class="noselect intro">R - {{ positionFromRightLimit }} mm</span>
  </div>
  <div class="button-container">
    <div class="button left" (click)="moveSliderLeft()">
      <div class="lesser"></div>
    </div>
    <div
      (dragstart)="stopDragBubble($event)"
      #container
      class="drag-container"
      (mousemove)="mouseMove($event)"
      (mouseup)="mouseUp()"
      (mouseleave)="mouseLeave()"
      (click)="moveSteps($event)"
      (wheel)="scrolling($event)">
      <div (dragstart)="stopDragBubble($event)" [style.width.%]="leftContainerSize" class="left-space"></div>
      <div #thumb class="thumb" (mousedown)="mouseDown($event)">
        <div class="rectangle" [ngClass]="{ collision: collided }">
          <div class="dot"></div>
        </div>
      </div>
      <div (dragstart)="stopDragBubble($event)" [style.width.%]="rightContainersize" class="right-space"></div>
    </div>
    <div class="button right" (click)="moveSliderRight()">
      <div class="greater"></div>
    </div>
  </div>
</div>
